import { StandardsList } from "./StandardsList";

export { StandardsList };
